import { colors } from '@/lib/analytics/colors';
import { KPI_VALUE_TIME } from '@/hooks/format/useFormatKpiValue';
import { SIZE_50 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerVideoDuration = {
    name: 'kpi.tiktok.video_duration',
    id: 'video_duration',
    icon: {
        name: 'play',
        style: colors.pink
    },
    data_format: KPI_VALUE_TIME,
    size: SIZE_50,
    mergedData: true,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    loader: MediaViewerKpiLoader
};
